export const KM_COMMON_TEST_IDS = {
    MAIN_NAVIGATION_MENU: "main-navigation-menu",
    NAV_LINKS: "km-nav-links",
    NAV_FAVORITES: "km-nav-favorites",
    NAV_APPLIED: "km-nav-applied",
    NAV_DISMISSED: "km-nav-dismissed",
    NAV_MESSAGES: "km-nav-messages",
    NAV_PREFERENCES: "km-nav-preferences",
    NAV_SETTINGS: "km-nav-settings",
    NAV_LOGOUT: "km-nav-logout",
    NAV_FAVORITES_COUNT: "km-nav-favorites-count"
};

export const KM_COMMON_TEST_IDS_MOBILE = {
    TAB_NAVIGATION_MENU: "tab-navigation-menu-mobile",
    HAMBURGER_MENU: "km-hamburger-menu",
    HAMBURGER_TRIGGER: "km-hamburger-trigger"
};
export const KM_COMMON_TEST_IDS = {
    MAIN_NAVIGATION_MENU: "main-navigation-menu",
    NAV_LINKS: "km-nav-links",
    NAV_FAVORITES: "km-nav-favorites",
    NAV_APPLIED: "km-nav-applied",
    NAV_DISMISSED: "km-nav-dismissed",
    NAV_MESSAGES: "km-nav-messages",
    NAV_PREFERENCES: "km-nav-preferences",
    NAV_SETTINGS: "km-nav-settings",
    NAV_LOGOUT: "km-nav-logout",
    NAV_FAVORITES_COUNT: "km-nav-favorites-count"
};

export const KM_COMMON_TEST_IDS_MOBILE = {
    TAB_NAVIGATION_MENU: "tab-navigation-menu-mobile",
    HAMBURGER_MENU: "km-hamburger-menu",
    HAMBURGER_TRIGGER: "km-hamburger-trigger"
};
